<section class="highlight-section py-5">
    <div class="container">
        <!-- Title -->
        <div class="row mb-4 text-center">
            <div class="col-12">
                <h6 class="text-uppercase fw-bold text-primary tracking-wide mb-2" style="letter-spacing: 2px;">Discover Our</h6>
                <h2 class="home-title mb-3">Holistic Learning Environment</h2>
                <p class="text-muted mx-auto" style="max-width: 700px;">
                    Explore our state-of-the-art facilities designed to foster creativity, critical thinking, and overall well-being.
                </p>
            </div>
        </div>

        <!-- Pills Navigation -->
        <div class="row mb-4">
            <div class="col-12">
                <div class="nav-pills-container">
                    <ul class="nav nav-pills justify-content-xl-center flex-nowrap overflow-auto hide-scrollbar pb-2" style="gap: 10px;">
                        <li class="nav-item" *ngFor="let item of facilities">
                            <button class="pill-btn" 
                                    [class.active]="selectedItem === item"
                                    [ngClass]="selectedItem === item ? item.colorClass : ''"
                                    (click)="setActive(item)">
                                <i [class]="item.icon"></i> <span>{{ item.title }}</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- Showcase Box -->
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10">
                <div class="showcase-card shadow-lg" [ngClass]="selectedItem.colorClass" *ngIf="selectedItem">
                    
                    <!-- Faded Background Icon -->
                    <div class="showcase-bg-icon">
                        <i [class]="selectedItem.icon"></i>
                    </div>

                    <div class="showcase-content">
                        <!-- Main Icon -->
                        <div class="showcase-icon-wrapper shadow-sm mb-4">
                            <i [class]="selectedItem.icon"></i>
                        </div>
                        
                        <h3 class="showcase-title display-6 fw-bold mb-3">{{ selectedItem.title }}</h3>
                        <p class="showcase-desc lead mb-0">{{ selectedItem.description }}</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>